import { render, staticRenderFns } from "./LocationTab.vue?vue&type=template&id=66da1a86&scoped=true"
import script from "./LocationTab.vue?vue&type=script&lang=js"
export * from "./LocationTab.vue?vue&type=script&lang=js"
import style0 from "./LocationTab.vue?vue&type=style&index=0&id=66da1a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da1a86",
  null
  
)

export default component.exports